import React, { useState, useEffect } from "react";
import '../styles/tiles.css';
import '../styles_m/tiles_m.css';
import '../styles/other.css';
import Axios from 'axios';
import { Link } from "react-router-dom";
import { navigate } from "@reach/router";

// import utilities
import { checkForErrorsInRequest } from '../utilities/RequestsUtilities.js';

class ApplicationHistoryTile extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
        }
    }

    componentDidMount(){
        this.loadData();
    }

    loadData = async () => {

    }

    render() {
        return (
            <div className={"universalAddTile"} style={{position: "relative", marginBottom: 20}}>
                <div className="verticalStack">
                    <span className="fontPoppinsSemiBold15">Application History:</span>

                    <span className="fontPoppinsRegular13DarkGray" style={{marginTop: 10}}>Created: <span className="fontPoppinsRegular13Gray">June 6, 2024</span></span>
                    <span className="fontPoppinsRegular13DarkGray">1st level approved: <span className="fontPoppinsRegular13Gray">July 20, 2024</span></span>
                    <span className="fontPoppinsRegular13DarkGray">2nd level approved: <span className="fontPoppinsRegular13Gray">August 5, 2024</span></span>
                    <span className="fontPoppinsRegular13DarkGray">3rd level approved: <span className="fontPoppinsRegular13Gray">August 12, 2024</span></span>
                    <span className="fontPoppinsRegular13DarkGray">Funding Identified: <span className="fontPoppinsRegular13Gray">September 2, 2024</span></span>
                    <span className="fontPoppinsRegular13DarkGray">Funds In: <span className="fontPoppinsRegular13Gray">waiting</span></span>
                </div>
            </div>
        );
    }
}

export default ApplicationHistoryTile;
